export default __webpack_public_path__ + "static/media/PLUR.d1a0699b.png";